import {
  TooltipTrigger,
  Tooltip as UITooltip,
} from "@light-technology/components";
import { AlertCircle } from "@untitledui/icons";

type ChartErrorIconProps = {
  show: boolean;
};

export function ChartErrorIcon({ show }: ChartErrorIconProps) {
  if (!show) return null;

  return (
    <UITooltip
      title="The data could not load at this time. Please try again later."
      placement="right"
    >
      <TooltipTrigger>
        <AlertCircle className="size-5 text-fg-error-primary" />
      </TooltipTrigger>
    </UITooltip>
  );
}
